export const textEncoder = new TextEncoder();
